<div class="rd-widget rd-widget-no-height-restriction cap-rate-calculations-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="30" class="widget-grid-column cap-rate-calculations-widget-header-red align-left">
            <widget-value class="cap-rate-calculations-widget-header" [align]="'left'" [color]="'white'" [bold]="true">{{'directCapCapRateCalculations.labelCapitalizationRateCalculations' | rdTranslate}}</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="top-row">
          <td colspan="30" class="darkGreyTableHeader"><label class="align-left header-label">{{'directCapCapRateCalculations.labelCapitalizationRateVariables' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="10"><label>{{'directCapCapRateCalculations.usCapitalizationRateCalculationsMortgageInterestRate' | rdTranslate}}</label></td>
          <td colspan="20"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsMortgageInterestRate * 100 | rdLocalizedNumber}}%</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="4" [widget]="this">
        <tr class="white-line">
          <td colspan="10"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsAmortizationTermYears' | rdTranslate}}</label></td>
          <td colspan="20"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsAmortizationTermYears}}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="5" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="10"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsLoanToValueRatio' | rdTranslate}}</label></td>
          <td colspan="20"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsLoanToValueRatio * 100 | rdLocalizedNumber}}%</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="6" [widget]="this">
        <tr class="white-line">
          <td colspan="10"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsDebtCoverageRatio' | rdTranslate}}</label></td>
          <td colspan="20"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsDebtCoverageRatio | rdLocalizedNumber}}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="7" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="10"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsEquityDividendRate' | rdTranslate}}</label></td>
          <td colspan="20"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsEquityDividendRate * 100 | rdLocalizedNumber}}%</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="8" [widget]="this">
        <tr class="top-row">
          <td colspan="30" class="darkGreyTableHeader"><label class="header-label">{{'directCapCapRateCalculations.labelBandOfInvestmentAnalysis' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="9" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="5"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsMortgageConstant' | rdTranslate}}</label></td>
          <td colspan="5"></td>
          <td colspan="5"><widget-value [align]="'left'"><label>{{'directCapCapRateCalculations.usCapitalizationRateCalculationsLoanRatio' | rdTranslate}}</label></widget-value></td>
          <td colspan="5"></td>
          <td colspan="5"><widget-value [align]="'left'"><label>{{'directCapCapRateCalculations.usCapitalizationRateCalculationsContributions' | rdTranslate}}</label></widget-value></td>
          <td colspan="5"></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="10" [widget]="this">
        <tr class="white-line">
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsMortgageConstant}}</widget-value></td>
          <td colspan="2"></td>
          <td colspan="1">x</td>
          <td colspan="2"></td>
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsLoanRatio * 100 | rdLocalizedNumber}}%</widget-value></td>
          <td colspan="2"></td>
          <td colspan="1">=</td>
          <td colspan="2"></td>
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsContributions * 100 | rdLocalizedNumber}}%</widget-value></td>
          <td colspan="5"></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="11" [widget]="this">
        <tr class="light-grey-line">
          <td colspan="5"><label class="align-left">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsEquityDividendRate2' | rdTranslate}}</label></td>
          <td colspan="5"></td>
          <td colspan="5"><widget-value [align]="'left'"><label>{{'directCapCapRateCalculations.usCapitalizationRateCalculationsEquityRatio' | rdTranslate}}</label></widget-value></td>
          <td colspan="15"></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="12" [widget]="this">
        <tr class="white-line">
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsEquityDividendRate2 * 100 | rdLocalizedNumber}}%</widget-value></td>
          <td colspan="2"></td>
          <td colspan="1">x</td>
          <td colspan="2"></td>
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsEquityRatio * 100 | rdLocalizedNumber}}%</widget-value></td>
          <td colspan="2"></td>
          <td colspan="1">=</td>
          <td colspan="2"></td>
          <td colspan="5"><widget-value [align]="'left'">{{widgetData.usCapitalizationRateCalculationsContributions2 * 100 | rdLocalizedNumber}}%</widget-value></td>
          <td colspan="5"></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="13" [widget]="this">
        <tr class="darkGreyTableHeader">
          <td colspan="10"></td>
          <td colspan="10"><widget-value [align]="'left'"><label class="header-label">{{'directCapCapRateCalculations.usCapitalizationRateCalculationsBandOfInvestmentCapitalizationRate' | rdTranslate}}</label></widget-value></td>
          <td colspan="10"><widget-value [align]="'left'"><label class="header-label">{{widgetData.usCapitalizationRateCalculationsBandOfInvestmentCapitalizationRate * 100 | rdLocalizedNumber}}%</label></widget-value></td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
